import Flex from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled from '../../../theme'

const FilterBarContainer = styled(Flex as any)<IFilterBarContainerProps>`
  width: 100%;

  @media (max-width: 1200px) {
    ${is('currency')`
      font-size: 0.75em;
  `}
  }
`

export { FilterBarContainer }

export interface IFilterBarContainerProps {
  currency?: boolean
}
